


















































































import moment from 'moment'

import { ValidationObserver, ValidationProvider } from 'vee-validate'

import { Component, Emit, Model, Prop, Vue, Watch } from 'vue-property-decorator'

import { ListItem } from '@/layouts/components'

import { OrderFilters, OrderStatus } from '@/models'

import { isSetsEqual, normalizeDate } from '@/utils'

interface DateOptions {
  max?: string | null
  min?: string | null
}

@Component({
  components: {
    ListItem,
    ValidationObserver,
    ValidationProvider
  }
})
export default class OrderFiltersForm extends Vue {
  @Model('change', { type: Object, default: null })
  readonly data!: OrderFilters | null

  @Prop({ type: Object, required: true })
  readonly initialFilters!: OrderFilters

  isValid = false

  fromDate = ''

  fromDateOptions: DateOptions = {
    max: moment().format('YYYY-MM-DD')
  }

  untilDate = ''

  untilDateOptions: DateOptions = {
    min: null,
    max: moment().format('YYYY-MM-DD')
  }

  orderStatus: [OrderStatus, boolean][] = [
    [OrderStatus.AUTHORIZED, false],
    [OrderStatus.STARTED, false],
    [OrderStatus.COMPLETED, false],
    [OrderStatus.CANCELED, false]
  ]

  OrderStatusTexts: Record<OrderStatus, string> = {
    [OrderStatus.OPEN]: 'Aberto',
    [OrderStatus.AUTHORIZED]: 'Aguardando',
    [OrderStatus.STARTED]: 'Preparando',
    [OrderStatus.COMPLETED]: 'Completado',
    [OrderStatus.CANCELED]: 'Cancelado'
  }

  get enabledOrderStatus () {
    return this.orderStatus
      .filter((entry) => entry[1])
      .map((entry) => entry[0])
  }

  get isFormValid () {
    return this.isValid && this.enabledOrderStatus.length > 0
  }

  @Watch('data')
  onDataChange (filters: OrderFilters) {
    this.updateFields(filters)
  }

  @Watch('fromDate')
  onFromDateChange (value: string) {
    const date = normalizeDate(value)

    this.untilDateOptions.min = date

    this.updateModel()
  }

  @Watch('untilDate')
  onUntilDateChange (value: string) {
    const date = normalizeDate(value)

    this.fromDateOptions.max = date ?? this.untilDateOptions.max

    this.updateModel()
  }

  @Watch('orderStatus')
  onOrderStatusChange () {
    this.updateModel()
  }

  @Watch('isFormValid')
  onIsFormValidChange () {
    this.$emit('update:isValid', this.isFormValid)
  }

  created () {
    this.updateFields(this.initialFilters)
  }

  updateFields (filters: OrderFilters) {
    this.fromDate = filters.from ?? ''
    this.untilDate = filters.until ?? ''

    const statusFilter = filters.status ?? []

    if (!isSetsEqual(new Set(this.enabledOrderStatus), new Set(statusFilter))) {
      this.orderStatus = this.orderStatus
        .map((entry) => [entry[0], statusFilter.includes(entry[0])])
    }
  }

  /**
   * This is a hack because ValidationObserver does not emit a status event
   * and its validate() method returns a Promise.
   */
  setIsValid (valid: boolean) {
    this.isValid = valid
  }

  @Emit('change')
  updateModel (): OrderFilters {
    return {
      from: this.fromDate || undefined,
      until: this.untilDate || undefined,
      status: this.enabledOrderStatus
    }
  }

  submit () {
    if (this.isFormValid) {
      this.$emit('submit')
    }
  }
}
